import type { ReactNode } from 'react'
import styles from './ChartCard.module.css'

export type ChartCardProps = {
  title: string
  description?: string
  /** Set a wider card for charts that need horizontal room (treemap, trends). */
  wide?: boolean
  /** Set a taller plot area for dense charts (e.g. the treemap). */
  tall?: boolean
  /** Controls/legend rendered between the header and the plot, at their own
   * height — kept out of the fixed-height plot body so they don't push the
   * plot past the box. */
  controls?: ReactNode
  children: ReactNode
}

/** Card surface that frames one chart: a titled header, an optional controls
 * row, and a fixed-height plot area. Presentational — it owns no data. */
export default function ChartCard({
  title,
  description,
  wide = false,
  tall = false,
  controls,
  children,
}: ChartCardProps) {
  return (
    <article className={`${styles.card} ${wide ? styles.wide : ''}`}>
      <header className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        {description !== undefined && <p className={styles.description}>{description}</p>}
      </header>
      {controls !== undefined && <div className={styles.controls}>{controls}</div>}
      <div className={`${styles.body} ${tall ? styles.bodyTall : ''}`}>{children}</div>
    </article>
  )
}
